import { createAlias } from '../core';
export const axisProperties = {
    properties: {
        'margin-x': createAlias([
            'margin-left',
            'margin-right'
        ]),
        'margin-y': createAlias([
            'margin-top',
            'margin-bottom'
        ]),
        'padding-x': createAlias([
            'padding-left',
            'padding-right'
        ]),
        'padding-y': createAlias([
            'padding-top',
            'padding-bottom'
        ])
    }
};

//# sourceMappingURL=axisProperties.js.map